__turbopack_context__.v({
  "bone": "skeleton-module-scss-module__Pel-Ya__bone",
  "bone-image": "skeleton-module-scss-module__Pel-Ya__bone-image" + " " + "skeleton-module-scss-module__Pel-Ya__bone",
  "bone-round": "skeleton-module-scss-module__Pel-Ya__bone-round" + " " + "skeleton-module-scss-module__Pel-Ya__bone",
  "skeleton-shimmer": "skeleton-module-scss-module__Pel-Ya__skeleton-shimmer",
});
